import React from "react";
import { connect } from "react-redux";
import { chatActions } from "_actions";
import { AppearFromBottom, QuicklinkButton, QuickLinkText } from "global/style";
import styled from "styled-components";
import QuicklinkButtonImage from "./Components/QuicklinkButton.Image";
import { useState } from "react";

const LinkIcon = styled.img`
  width: 21px;
  height: 20px;

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    width: 31px;
    height: 28px;
  }
`;

const RedirectQuickLinkText = styled(QuickLinkText)`
  width: 200px;
  justify-content: space-between;
  padding-left: 20px;
  padding-right: 20px;
  font-weight: bold;
  font-size: 14px;
  line-height: 14px;

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakSmall}) {
    font-size: 16px;
  }

  @media screen and (min-width: ${(prop) =>
      prop.theme.screenSizes.breakLaptop}) {
    font-size: 17px;
    width: 250px;
    line-height: 1;
  }
`;

function Redirect({ data, send, activeTheme }) {
  const handleClick = () => {
    window.open(data.link, "_blank");
    if (data.proceed_intent) {
      data.value = data.proceed_intent;
      send(data, "text");
    }
  };

  const handleClickQuicklink = (e) => {
    if (e.key === "Enter" || e.key === " ") {
      handleClick();
    }
  };

  const [linkIcon, setLinkIcon] = useState(
    `/images/${activeTheme === "dark" ? "dark-mode" : "light-mode"}/link.png`
  );

  const chatWithAResidentImage =
    typeof data.image !== "undefined" ? data.image : null;

  return (
    <AppearFromBottom className="AppearFromBottom">
      <QuicklinkButton
        className="QuickLinkButton"
        onClick={handleClick}
        tabIndex={0}
        role="button"
        onKeyPress={(e) => handleClickQuicklink(e)}
        onMouseOver={() => setLinkIcon(`/images/dark-mode/link.png`)}
        onMouseLeave={() => setLinkIcon(`/images/light-mode/link.png`)}
      >
        <RedirectQuickLinkText
          className="RedirectQuickLinkText quicklinks"
          tabIndex={-1}
        >
          <LinkIcon src={linkIcon} />
          <span>{data.text}</span>
        </RedirectQuickLinkText>
        {chatWithAResidentImage && (
          <QuicklinkButtonImage
            text={data.text}
            image={chatWithAResidentImage}
          ></QuicklinkButtonImage>
        )}
      </QuicklinkButton>
    </AppearFromBottom>
  );
}

const mapStateToProps = (state) => ({
  activeTheme: state.settings.activeTheme,
});

const actions = {
  send: chatActions.send,
};

export default connect(mapStateToProps, actions)(Redirect);
